import React from 'react';
export const PingingVitalLogo = ({ height, width, }) => {
    const image = `https://cdn.shopify.com/s/files/1/2074/9385/files/vital-shield_${height}x${width}.png?v=1457225199074094420`;
    const styles = {
        height,
        width,
    };
    return (React.createElement("div", { className: "tailwind" },
        React.createElement("div", { className: "container p-8 flex flex-row justify-center items-center" },
            React.createElement("div", { className: "relative", style: styles },
                React.createElement("img", { className: "animate-ping absolute h-full w-full", src: image, alt: "Vital Proteins Logo" }),
                React.createElement("img", { className: "relative", src: image, alt: "Vital Proteins Logo", style: styles })))));
};
